module.exports = __webpack_public_path__ + "static/img/car.b20ed87f.png";